import type { BrandStoreSearchEntry } from '~/services/api/generated'

/** A brand store as the brand read and the store search publish it, with its review count normalized to a number. */
type BrandStoreCardSource = Pick<
  BrandStoreSearchEntry,
  'average_rating' | 'dine_in_available' | 'id' | 'name' | 'slug'
> &
  Partial<
    Pick<BrandStoreSearchEntry, 'address' | 'city' | 'cover' | 'distance_miles' | 'state'>
  > & {
    review_count: number
  }

interface BrandStoreCardView extends Pick<BrandStoreCardSource, 'average_rating' | 'review_count'> {
  id: number
  name: string
  slug: string
  cover?: string
  state?: string
  address?: string
  city?: string
  dine_in_available: boolean
  distance_miles?: number
}

/** StoreCard props for a brand store; absent optional fields are omitted rather than passed empty. */
export const toBrandStoreCardView = (store: BrandStoreCardSource): BrandStoreCardView => {
  const distanceMiles = 'distance_miles' in store ? store.distance_miles : undefined

  return {
    dine_in_available: store.dine_in_available,
    id: store.id,
    name: store.name,
    slug: store.slug,
    ...(store.cover === null || store.cover === undefined ? {} : { cover: store.cover }),
    ...(store.state === null || store.state === undefined ? {} : { state: store.state }),
    ...(store.address === null || store.address === undefined ? {} : { address: store.address }),
    ...(store.city === null || store.city === undefined ? {} : { city: store.city }),
    average_rating: store.average_rating,
    review_count: store.review_count,
    ...(distanceMiles === null || distanceMiles === undefined
      ? {}
      : { distance_miles: distanceMiles })
  }
}
